<template>
  <el-dialog
    title=""
    :modelValue="modelValue"
    width="930px"
    @closed="CloseDialog"
  >
    <div class="approval-history">
      <el-scrollbar height="800px"
        ><div
          v-for="(item, a) in ApprovalHistory"
          :key="'approvalHistories' + a"
        >
          <div
            style="
              font-size: 17px;
              line-height: 26px;
              padding-left: 15px;
              padding-bottom: 15px;
              font-weight: 700;
            "
          >
            {{ item.name }}
          </div>
          <div
            v-for="(b, a1) in item.data"
            :key="'b_' + a1"
            style="
              border-bottom: 3px double #e2e2ea;
              padding-top: 15px;
              margin-bottom: 15px;
            "
          >
            <el-timeline class="approval-timeline">
              <el-timeline-item
                placement="top"
                :hollow="true"
                :hide-timestamp="true"
                :icon="c.icon"
                v-for="(c, a2) in b.data"
                :key="'c' + a2"
                style="padding-bottom: 10px"
              >
                <div style="display: flex">
                  <div class="title" style="width: 60%">{{ c.title }}</div>
                  <div
                    class="approve-time"
                    style="
                      width: 40%;
                      text-align: right;
                      letter-spacing: 0.05rem;
                    "
                  >
                    {{ c.approveTime }}
                  </div>
                </div>
                <div>
                  <div
                    class="text"
                    v-for="(text, index) in c.content"
                    :key="'text1_' + index"
                  >
                    <div>{{ text }}</div>
                  </div>
                </div>
                <div :class="{ divider: a2 < b.data.length - 1 }"></div>
              </el-timeline-item>
            </el-timeline>
          </div></div
      ></el-scrollbar>
    </div>
  </el-dialog>
</template>

<script setup>
import { h, ref } from 'vue';
import { formatter_datetime } from '@/assets/js/formatter';
const props = defineProps({
  modelValue: {
    type: Boolean,
    description: '启用/隐藏',
  },
  cId: {
    type: String,
    default: '',
    description: '合同id',
  },
});

const ApprovalHistory = ref([]);
const signedContractHistories = ref([]);

const setApprovalHistory = (entity, isLatest) => {
  var content = [];
  if (entity.status === 'Submit' || entity.status === 'Cancel') {
    content.push(`Contract No.: ${entity.contractNo}`);
  } else if (entity.status === 'Void') {
    content.push(`Contract No.: ${entity.contractNo}`);
    content.push(`Remark: ${entity.remark || ''}`);
  } else {
    content.push(`Approved By: ${entity.approverUserName}`);
    content.push(`Status: ${entity.status}`);
    content.push(`Remark: ${entity.remark || ''}`);
  }

  return {
    title: entity.title,
    approveTime: formatter_datetime(entity.approveDateTime, 'DD/MM/YYYY HH:mm'),
    icon: getApprovalIconRender(entity.status, isLatest),
    content,
  };
};

const getApprovalIconRender = (status, isLatest) => {
  var style = 'color:#999999';
  if (isLatest) {
    style = 'color:#fe9350';
  }

  if (status === 'Submit') {
    return h('div', [h('span', { class: 'matrix-icon-order', style })]);
  } else {
    return h('div', [h('span', { class: 'matrix-icon-approval', style })]);
  }
};

const init = () => {
  const contractnet = require('@/network/contractnet').default;

  // 流程记录
  contractnet.getApprovalHistories(props.cId).then((res) => {
    const data = res.data?.data || [];
    var approvalHistories = [];
    // var approvalData = [];
    // var approvalDataLatest = [];
    // var signedData = [];
    // var signedDataLatest = [];

    for (var i = 0; i < data.length; i++) {
      var element = data[i];
      const approvalName = element.approvalName;
      const approval_time = element.approval_time;
      const isLatest = element.isLatest;

      if (!approvalHistories.find((t) => t.name === approvalName)) {
        approvalHistories.push({
          name: approvalName,
          data: [],
        });
      }

      var historyData =
        approvalHistories.find((t) => t.name === approvalName) || null;
      if (historyData === null) {
        return;
      }

      var index = approvalHistories.length - 1; // 顶层Index

      var approvalData =
        historyData.data.find((t) => t.time === approval_time) || null;
      if (approvalData === null) {
        approvalHistories[index].data.push({
          time: approval_time,
          data: [],
        });
      }

      var entity = setApprovalHistory(element, isLatest);
      approvalHistories[index].data[approval_time].data.push(entity);
    }

    // if (approvalHistoryLatest?.length > 0) {
    //   var approvalLatest = approvalHistoryLatest.sort(
    //     (a, b) =>
    //       new Date(a.approveDateTime).getTime() -
    //       new Date(b.approveDateTime).getTime()
    //   );

    //   approvalLatest.map((t) => {
    //     approvalDataLatest.push(setApprovalHistory(t, true));
    //   });
    // }

    // // SignedContractApproval流程审批记录
    // if (signedContractApprovals?.length > 0) {
    //   var signedContract = signedContractApprovals.sort(
    //     (a, b) =>
    //       new Date(a.approveDateTime).getTime() -
    //       new Date(b.approveDateTime).getTime()
    //   );

    //   signedContract.map((t) => {
    //     signedData.push(setApprovalHistory(t, true));
    //   });
    // }

    // if (signedContractApprovals_Latest?.length > 0) {
    //   var signedContractLatest = signedContractApprovals_Latest.sort(
    //     (a, b) =>
    //       new Date(a.approveDateTime).getTime() -
    //       new Date(b.approveDateTime).getTime()
    //   );

    //   signedContractLatest.map((t) => {
    //     signedDataLatest.push(setApprovalHistory(t, true));
    //   });
    // }

    // if (approvalData.length > 0 || approvalDataLatest.length > 0) {
    //   approvalHistories.push({ name: 'Approval History' });
    // }

    ApprovalHistory.value = approvalHistories;
    console.log('getApprovalHistories', data, approvalHistories);
  });
};
init();

const emits = defineEmits(['update:modelValue']);

// 关闭窗口
const CloseDialog = () => {
  emits('update:modelValue', false);
};
</script>
<style scoped>
.approval-history .title {
  color: #423022;
  font-size: 14px;
  font-weight: 700;
  padding-bottom: 5px;
}
.approval-history .approve-time {
  color: #7d7167;
  font-size: 13px;
  font-weight: 700;
}
.approval-history .text {
  color: #979797;
  font-size: 12px;
  padding-bottom: 5px;
}
.divider {
  border-bottom: 1px solid #e2e2ea;
}
</style>
<style>
.approval-history .el-icon.el-timeline-item__icon {
  font-size: 19px !important;
}
.approval-history .el-timeline-item__tail {
  border-style: dotted;
}
.approval-timeline .el-timeline-item:last-child {
  padding-bottom: 0;
}
.approval-timeline .el-timeline-item__node {
  border-width: 0px !important;
}
</style>
